var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("UiButtonMessage", {
        attrs: {
          label: "add black",
          buttonClass: "customAdd",
          buttonText: "Add manager",
        },
        on: { click: _vm.showModal },
      }),
      _vm.modalShown
        ? _c(
            "AddEmployeeModal",
            {
              attrs: { saveDisabled: !_vm.isSelected, title: "Add Manager" },
              on: { close: _vm.closeModal, add: _vm.addContractorToManagers },
            },
            [
              _c("ManagersMultiselect", {
                attrs: {
                  getParentcontainerStyle: "customWidthInput",
                  additionalConditions: _vm.conditions,
                  withEmailSearch: "",
                },
                model: {
                  value: _vm.selectedManagersIds,
                  callback: function ($$v) {
                    _vm.selectedManagersIds = $$v
                  },
                  expression: "selectedManagersIds",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }